import { FC, useMemo, useState } from 'react'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { rewardsLifetimeChartSelector } from 'selectors/bountySelectors'
import ModuleWrapper2020 from 'components/features/pfm/ModuleWrapper2020/ModuleWrapper2020'
import { ChartPresetHeading } from 'components/features/rewards/rewardPage/ChartPresetHeading/ChartPresetHeading'
import { LifetimeEarningsChart } from 'components/features/rewards/rewardPage/LifetimeEarningsChart/LifetimeEarningsChart'
import moment from 'moment'
import styles from 'components/features/rewards/rewardPage/LifetimeEarnings/LifetimeEarnings.styl'

type LifetimeEarningsProps = {
  className: string
}
export const LifetimeEarnings: FC<LifetimeEarningsProps> = (props) => {
  const { className } = props
  const chartData = useStoreSelector(rewardsLifetimeChartSelector)

  const [hoverIndex, setHoverIndex] = useState(0)

  const { cashValue, cryptoValue } = useMemo(() => ({
    cashValue: chartData?.usd[hoverIndex]?.amount ?? 0,
    cryptoValue: chartData?.crypto[hoverIndex]?.amount ?? 0,
  }), [hoverIndex, chartData])

  const headerLabel = useMemo(() => {
    if (!chartData || hoverIndex === chartData.crypto.length - 1 || !chartData.crypto[hoverIndex]) {
      return 'TODAY'
    }

    const headerDate = chartData.crypto[hoverIndex].date
    return `${ moment(headerDate).format('MMMM').toUpperCase() } ${ moment(headerDate).format('Do') }`
  }, [chartData, hoverIndex])

  if (!chartData || chartData.crypto.length === 0) {
    return null
  }

  return (
    <ModuleWrapper2020
      title='Lifetime Earnings'
      corners='all'
      forceRoundedCorners
      shadowTheme='regular'
      className={ className }
    >
      <ChartPresetHeading
        headerLabel={ headerLabel }
        cashLabel='CASH REWARDS'
        cash={ cashValue }
        cryptoLabel='WITH CRYPTO'
        crypto={ cryptoValue }
      />
      <div className={ styles.chart }>
        <LifetimeEarningsChart data={ chartData } onHover={ setHoverIndex } />
      </div>
    </ModuleWrapper2020>
  )
}
